<template>
  <Content>
    <form @submit.prevent="submitForm">
      <div class="container-fluid py-4">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h3 class="page-title mb-1">{{ currentLang.title }}</h3>
            <p class="page-subtitle mb-0">
              {{ currentLang.detail }}
            </p>
          </div>

          <button
            @click="$router.push('/admin')"
            class="btn btn-light back-btn"
          >
            {{ currentLang.back }}
          </button>
        </div>

        <ErrorAlert v-if="errorMessage" :message="errorMessage" />

        <div class="row g-4">
          <div class="col-12 col-md-6">
            <label class="custom-label">
              {{ currentLang.mobile }}
              <span class="required">*</span>
            </label>

            <input
              type="text"
              class="form-control custom-input"
              :placeholder="currentLang.placeholderMobile"
              v-model="form.mobile"
              :disabled="isEdit"
              required
            />
          </div>

          <div class="col-12 col-md-6">
            <label class="custom-label">
              {{ currentLang.status }}
              <span class="required">*</span>
            </label>

            <select class="form-select custom-input" v-model="form.status">
              <option value="active">{{ currentLang.statusActive }}</option>
              <option value="inactive">{{ currentLang.statusInActive }}</option>
            </select>
          </div>

          <div class="col-12 col-md-6">
            <label class="custom-label">
              {{ currentLang.firstName }}
              <span class="required">*</span>
            </label>

            <input
              type="text"
              class="form-control custom-input"
              :placeholder="currentLang.placeholderFirstName"
              v-model="form.first_name"
            />
          </div>

          <div class="col-12 col-md-6">
            <label class="custom-label">
              {{ currentLang.lastName }}
              <span class="required">*</span>
            </label>

            <input
              type="text"
              class="form-control custom-input"
              :placeholder="currentLang.placeholderLastName"
              v-model="form.last_name"
            />
          </div>
        </div>

        <div class="d-flex justify-content-end mt-5">
          <button class="btn save-btn" :disabled="loading">
            {{ loading ? currentLang.saving : currentLang.save }}
          </button>
        </div>
      </div>
    </form>
  </Content>
</template>
<script setup>
import { alertStore } from "@/stores/alertStore";
import Content from "@/components/AdminContent.vue";
import { lang } from "@/plugins/lang";
import { ref, watch, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import api from "@/plugins/axios";
import ErrorAlert from "@/components/alerts/ErrorAlert.vue";
const errorMessage = ref("");
const route = useRoute();
const router = useRouter();
const isEdit = computed(() => !!route.params.id);
import { showLoading, hideLoading } from "@/stores/loading";

import enText from "@/locales/en/adminForm";
import faText from "@/locales/fa/adminForm";

const translations = {
  en: enText,
  fa: faText,
};
const currentLang = computed(() => translations[lang.value]);

const loading = ref(false);

const form = ref({
  mobile: "",
  first_name: "",
  last_name: "",
  status: "active",
});

const submitForm = async () => {
  try {
    loading.value = true;
    showLoading();

    const response = isEdit.value
      ? await api.patch(`admin/user/${route.params.id}`, form.value)
      : await api.post("admin/user", form.value);

    if (response.status === 201 || response.status === 200) {
      hideLoading();
      alertStore.trigger(
        "success",
        currentLang.value.success,
        response?.data?.message || ""
      );
      router.push("/admin");
    } else {
      const errors = error.response?.data?.message || "خطا در آپلود تصویر";
      const validationErrors = error.response?.data?.errors;
      let displayMessage = errors;

      if (validationErrors && typeof validationErrors === "object") {
        // تبدیل خطاهای ولیدیشن به یک متن واحد
        displayMessage = Object.values(validationErrors).flat().join(", ");
      }
      errorMessage.value = displayMessage;
    }
  } catch (error) {
    const errors = error.response?.data?.message || "خطا در آپلود تصویر";
    const validationErrors = error.response?.data?.errors;
    let displayMessage = errors;

    if (validationErrors && typeof validationErrors === "object") {
      // تبدیل خطاهای ولیدیشن به یک متن واحد
      displayMessage = Object.values(validationErrors).flat().join(", ");
    }
    errorMessage.value = displayMessage;
  } finally {
    loading.value = false;
    hideLoading();
  }
};

const getUser = async () => {
  try {
    loading.value = true;
    showLoading();

    const response = await api.get(`admin/user/${route.params.id}`);

    const user = response.data.data;

    form.value.mobile = user.mobile;
    form.value.first_name = user.first_name;
    form.value.last_name = user.last_name;
    form.value.status = user.status;
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
    hideLoading();
  }
};
const resetForm = () => {
  form.value.mobile = "";
  form.value.first_name = "";
  form.value.last_name = "";
};

watch(
  () => route.params.id,
  (id) => {
    if (id) {
      getUser();
    } else {
      resetForm();
    }
  },
  { immediate: true }
);
</script>


<style scoped>



.page-title {
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
}

.page-subtitle {
  color: #64748b;
  font-size: 14px;
}

.custom-label {
  display: block;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #334155;
}

.custom-input {
  height: 48px;
  border-radius: 10px;
  border: none;
  font-size: 14px;
  padding: 0 14px;
  transition: 0.2s ease;
  background: #fff;

  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.08);
}

.custom-input:focus {
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.08),
    0 0 0 3px rgba(59, 130, 246, 0.15);

  outline: none;
}


.save-btn {
  min-width: 160px;
  height: 46px;
  border: none;
  border-radius: 10px;
  background: #16a34a;
  color: white;
  font-weight: 600;
  padding: 0 24px;
  transition: 0.2s ease;

  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.25);
}

.save-btn:hover {
  background: #15803d;
  color: white;
}



.back-btn {
  border: none;
  border-radius: 10px;
  padding: 10px 18px;
  background: #ffffff;
  color: #334155;
  font-weight: 600;
  transition: 0.2s ease;

  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.08);
}

.back-btn:hover {
  background: #f8fafc;
  color: #0f172a;

  transform: translateY(-1px);

  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);
}

.custom-input:disabled {
  background: #f1f5f9;
  cursor: not-allowed;
  opacity: 0.8;
}

@media (max-width: 768px) {
  .page-title {
    font-size: 22px;
  }

  .save-btn {
    width: 100%;
  }
}
.required {
  color: red;
  margin-right: 4px;
}
</style>